// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmarks-row {
  /* margin-top: 3rem; */
}

.nav-tabs {
  /* border-bottom: none !important; */
}

.nav-link {
  border-radius: 0 !important;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  -ms-border-radius: 0 !important;
  -o-border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/BookmarksPanel/BookmarksPanel.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AACA;EACI,oCAAA;AAEJ;;AAAA;EACI,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;AAGJ","sourcesContent":[".bookmarks-row {\n    /* margin-top: 3rem; */\n}\n.nav-tabs {\n    /* border-bottom: none !important; */\n}\n.nav-link {\n    border-radius: 0 !important;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    -ms-border-radius: 0 !important;\n    -o-border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
